// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-cropper.hide-cropper {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.upload-cropper {
  position: relative;
  width: 100%;
  min-width: 100px;
  min-height: 100px;
  height: auto;
  top: 0;
  pointer-events: none;
}
.upload-cropper .image-cropper.shown {
  padding: 0;
  width: 100%;
  min-height: 250px;
  box-sizing: border-box;
  pointer-events: initial;
  margin-bottom: var(--motes-padding);
}
.upload-cropper .drop-zone-error {
  color: #dd4b39;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  box-sizing: border-box;
  transition: 200ms;
  opacity: 0;
  pointer-events: none;
}
.upload-cropper .drop-zone-error.shown {
  opacity: 1;
  pointer-events: initial;
}
.upload-cropper .crop-buttons {
  display: flex;
  justify-content: center;
  pointer-events: initial;
  flex-wrap: wrap;
}
.upload-cropper .crop-buttons button {
  width: 30%;
  margin: 5px;
}
.upload-cropper .crop-buttons .button-outline {
  color: inherit;
}
.upload-cropper .cropper-actions {
  position: relative;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/upload-cropper/upload-cropper.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;EACA,oBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,MAAA;EACA,oBAAA;AACJ;AAKI;EACI,UAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mCAAA;AAHR;AAMI;EACI,cAAA;EACA,aAAA;EACA,0CAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;EACA,oBAAA;AAJR;AAOI;EACI,UAAA;EACA,uBAAA;AALR;AAQI;EACI,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;AANR;AAQQ;EACI,UAAA;EACA,WAAA;AANZ;AASQ;EACI,cAAA;AAPZ;AAWI;EACI,kBAAA;EACA,WAAA;AATR","sourcesContent":[".upload-cropper.hide-cropper {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n}\n\n.upload-cropper {\n    position: relative;\n    width: 100%;\n    min-width: 100px;\n    min-height: 100px;\n    height: auto;\n    top: 0;\n    pointer-events: none;\n\n    image-cropper {\n        // background-color: gray;\n    }\n    \n    .image-cropper.shown {\n        padding: 0;\n        width: 100%;\n        min-height: 250px;\n        box-sizing: border-box;\n        pointer-events: initial;\n        margin-bottom: var(--motes-padding);\n    }\n\n    .drop-zone-error {\n        color: #dd4b39;\n        padding: 10px;\n        background-color: rgba(255, 255, 255, 0.9);\n        box-sizing: border-box;\n        transition: 200ms;\n        opacity: 0;\n        pointer-events: none;\n    }\n\n    .drop-zone-error.shown {\n        opacity: 1;\n        pointer-events: initial;\n    }\n\n    .crop-buttons {\n        display: flex;\n        justify-content: center;\n        pointer-events: initial;\n        flex-wrap: wrap;\n\n        button {\n            width: 30%;\n            margin: 5px;\n        }\n\n        .button-outline {\n            color: inherit;\n        }\n    }\n\n    .cropper-actions {\n        position: relative;\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
